import React from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { PayPalProvider, usePayPal } from './contexts/PayPalContext';
import PayPalSummaryCards from './components/PayPalSummaryCards';
import PayPalTransactionList from './components/PayPalTransactionList';

const bankingBreadCrumbs = [
  { title: 'Dashboard', path: '/dashboard', isSeparator: false, isActive: false },
  { title: '', path: '', isSeparator: true, isActive: false },
];

// PayPal Content
function PayPalContent() {
  const { connectionStatus, connectionLoading, syncing, syncTransactions } = usePayPal();

  if (connectionLoading) {
    return (
      <div className="card">
        <div className="card-body py-10 text-center">
          <span className="spinner-border text-primary" role="status" />
          <div className="text-muted mt-3">Loading PayPal...</div>
        </div>
      </div>
    );
  }

  if (!connectionStatus?.connected) {
    return (
      <div className="card">
        <div className="card-body py-10 text-center">
          <i className="bi bi-paypal fs-1 text-muted"></i>
          <div className="fw-bold fs-4 mt-4">PayPal not connected</div>
          <div className="text-muted mt-2">
            Connect your PayPal business account from Settings to enable payment tracking.
          </div>
          <a className="btn btn-primary mt-5" href="/user/account/settings#integrations">
            Go to Settings
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="banking-page">
      {/* Toolbar (mb-5 spaces it under terminal/metronic; the Graphite
          vertical-stack rule zeroes the margin and uses its gap instead) */}
      <div className="d-flex align-items-center justify-content-end mb-5">
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-light-primary btn-sm"
            onClick={() => syncTransactions({ fullSync: true })}
            disabled={syncing}
          >
            {syncing ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Full Sync...
              </>
            ) : (
              <>
                <i className="bi bi-cloud-download me-2"></i>
                Full Sync
              </>
            )}
          </button>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => syncTransactions()}
            disabled={syncing}
          >
            {syncing ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Syncing...
              </>
            ) : (
              <>
                <i className="bi bi-arrow-clockwise me-2"></i>
                Sync Now
              </>
            )}
          </button>
        </div>
      </div>

      <PayPalSummaryCards />
      <PayPalTransactionList />
    </div>
  );
}

export default function BankingPage() {
  return (
    <>
      <PageTitle breadcrumbs={bankingBreadCrumbs}>Bank Reconciliation</PageTitle>
      <PayPalProvider>
        <PayPalContent />
      </PayPalProvider>
    </>
  );
}
